import BackOfficePage from 'pages/BackOfficePage/BackOfficePage';

export default BackOfficePage;
